import { WithPlacement } from 'interfaces/insights'
import { OpportunityPlacement } from 'interfaces/opportunities'
import { SimpleGuard } from 'interfaces/guards'
import { getSocialInsightsActionCreator } from 'actions/socialInsightsActions'
import { SOCIAL_INSIGHT_PAGES_BY_PLACEMENT } from 'constants/insights'
import { createIsPlacementUpToDateSelector } from 'selectors/insightsSelectors'

export const socialInsightsGuard: SimpleGuard<WithPlacement<OpportunityPlacement>> = {
  name: 'SocialInsights',
  checker: createIsPlacementUpToDateSelector(),
  loader: (dispatch, { placement }) => {
    const page = SOCIAL_INSIGHT_PAGES_BY_PLACEMENT[placement]

    dispatch(getSocialInsightsActionCreator.request({ page }))
  },
}
